import { optionSubcategory_availability } from './availabilitySubCategory.locstring.json';
import { OptionSubCategory } from 'owa-options-core';
import AvailabilityOption from 'owa-calendar-availability-option/lib/AvailabilityOption';
import initializeAvailabilitySubCategory from './initializeAvailabilitySubCategory';

let availabilitySubCategory: OptionSubCategory = {
    key: 'availability',
    titleStringKey: optionSubcategory_availability,
    options: [AvailabilityOption],
    onSelected: initializeAvailabilitySubCategory,
};

export default availabilitySubCategory;
